/**
 * Enum for product table fields
 * @readonly
 * @enum {Array}
 */
export const USER_TABLE_FIELDS = Object.freeze([
	{ key: 'name', label: 'Name' },
	{ key: 'email', label: 'Email' },
	{ key: 'role', label: 'Role' },
	{ key: 'updated_at', label: 'Date Modified' },
	{ key: 'is_active', label: 'Status' },
]);

/**
 * Enum for user status
 * @readonly
 * @enum {String}
 */
export const USER_STATUS = Object.freeze({
	ACTIVE: 1,
	INACTIVE: 0,
});

/**
 * Enum for user roles
 * @readonly
 * @enum {String}
 */
export const USER_ROLE = Object.freeze({
	ADMIN: 'admin',
	USER: 'user',
});